import { useState } from "react";
import { Maximize2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { IMAGES } from "@/lib/images";
import Reveal from "@/components/landing/Reveal";

// Padrão assimétrico que preenche a grade de 4 colunas sem buracos:
// 1ª foto 2x2, 2ª e 3ª pequenas, 4ª larga; restantes largas (última ocupa a linha se sobrar).
const spanFor = (i, n) => {
  if (i === 0) return "sm:col-span-2 sm:row-span-2";
  if (i < 3) return "";
  if (i === 3) return "sm:col-span-2";
  return i === n - 1 && (n - 4) % 2 === 1 ? "sm:col-span-4" : "sm:col-span-2";
};

export default function TourGallery({ tour }) {
  const [active, setActive] = useState(null);
  const photos = tour.gallery.map((key) => IMAGES[key]);

  return (
    <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
      <Reveal className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-amber-400">
            Galeria
          </p>
          <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-stone-50 sm:text-4xl">
            O que você{" "}
            <em className="font-accent font-medium italic text-amber-400">vai ver.</em>
          </h2>
        </div>
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-stone-500">
          {photos.length} fotos · clique para ampliar
        </p>
      </Reveal>

      <Reveal delay={0.1}>
        <div data-testid="tour-gallery" className="mt-12 grid auto-rows-[220px] grid-cols-1 gap-4 sm:grid-cols-4">
          {photos.map((src, i) => (
            <button
              key={src}
              onClick={() => setActive(src)}
              data-testid={`tour-gallery-item-${i + 1}`}
              aria-label={`Ampliar foto ${i + 1}`}
              className={`group relative overflow-hidden rounded-xl border border-white/10 ${spanFor(i, photos.length)}`}
            >
              <img
                src={src}
                alt={`${tour.name} — foto ${i + 1}`}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <span className="absolute inset-0 bg-[#0D1117]/0 transition-colors duration-300 group-hover:bg-[#0D1117]/30" />
              <Maximize2 className="absolute right-3 top-3 h-4 w-4 text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
            </button>
          ))}
        </div>
      </Reveal>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent
          data-testid="tour-gallery-lightbox"
          className="max-w-5xl border-white/10 bg-[#0D1117] p-2 text-stone-100"
        >
          <DialogTitle className="sr-only">Foto ampliada — {tour.name}</DialogTitle>
          {active && (
            <img src={active} alt={tour.name} className="max-h-[80vh] w-full rounded-lg object-contain" />
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
}
